<template>
  <div id="wrap_catalog">
      <img class="back_catalog" src="../assets/img/bg_black.jpg"/>
        <div class="top_pane">
            <div class="top_pane_wrap" v-show="basketState">
                <div class="back_link" @click="goBack()">Вернуться назад</div>
                <p class="top_pane_text">Ваша корзина: </p>
                <p class="top_pane_count">{{ content.length }} товара</p>
            </div>
        </div>
        <div class="basket-main_wrap_content">
            <div class="basket-wrap_content" v-if="basketState">
                <div class="basket-content-wrap-body">
                    <div class="basket-content">
                        <div class="basket-content_item" v-for="item in content" :key="item.name">
                            <div class="basket-content_item_wrap">
                                <img :src="item.main_photo.photo"/>
                                <div class="text">
                                    <p class="name">{{item.mark.name}} {{ item.name }}</p>
                                    <p class="descript-basket">{{ item.description.text }}</p>
                                    <p class="more" @click="goToItem( item )">Подробнее о товаре</p>
                                </div>
                                <div class="price_wrap">
                                    <!-- <p class="price">{{ item.price }} Руб</p> -->
                                </div>
                                <div class="mobile_more_icon" @click="goToItem( item )"><img src="data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2Ij4NCiAgPGcgZmlsbD0iI2ZmZiI+DQogICAgPHBhdGggZD0iTTEyNi42OSAwaDEuOWMyNi42Ny4yNyA1My4yNyA4Ljc3IDc0Ljc0IDI0LjY4IDI0LjMzIDE3LjYxIDQyLjEgNDQuMTEgNDkuMDIgNzMuMzYgMi40MSA5LjM2IDMuMjQgMTkuMDMgMy42NSAyOC42NnYxLjljLS4zMSAyMi41NC02LjIzIDQ1LjA5LTE3LjkgNjQuNDMtMTcuMDkgMjkuMjItNDYuMzEgNTEuMS03OS4yMSA1OS4wOC05Ljg3IDIuNjMtMjAuMDkgMy41My0zMC4yNyAzLjg5aC0xLjcyYy0yNi4yNy0uMzgtNTIuNDMtOC43My03My42Ny0yNC4yNkMyOC44OSAyMTQuMjkgMTAuOTYgMTg4IDMuODkgMTU4Ljg3IDEuMyAxNDkuMjMuNDIgMTM5LjI0IDAgMTI5LjN2LTIuMzZjLjQyLTUuNjkuMzctMTEuNDMgMS40MS0xNy4wNiA0LjU3LTMzLjc5IDIzLjY0LTY1LjI1IDUxLjI2LTg1LjJDNzMuOTQgOC45MSAxMDAuMjcuNDMgMTI2LjY5IDBtLTEyLjI0IDE3Ljc3Yy0xNC44OSAxLjgyLTI5LjQgNi42Ni00Mi4zMyAxNC4yOEM0OS4yNSA0NS4zIDMxLjQyIDY3IDIyLjkyIDkyLjAzYy05LjE2IDI2LjU3LTcuNzUgNTYuNjcgNC4xMSA4Mi4xOCA5LjQyIDIwLjcgMjUuNDQgMzguMzMgNDUuMSA0OS43NCAyNC4zNyAxNC40MiA1NC40MyAxOC43MyA4MS45MSAxMiAyNS41My02LjAxIDQ4LjU4LTIxLjYxIDYzLjktNDIuODYgMTcuMTUtMjMuMzYgMjQuNDEtNTMuNjggMTkuNzQtODIuMjgtNC4yMy0yOC42OC0yMC41OC01NS4yMy00My45Ny03Mi4yOC0yMi40NS0xNi43OC01MS40OC0yNC4yNC03OS4yNi0yMC43NnoiLz4NCiAgICA8cGF0aCBkPSJNMTI0LjE4IDYyLjE5YzcuMzctMS45NCAxNS4zMSAyLjYxIDE3LjkzIDkuNjMgMi41MSA3LjA0LS42NCAxNS42OC03LjI4IDE5LjIyLTYuMTUgMy41NC0xNC44MiAxLjgzLTE5LjExLTMuODQtMi45NS0zLjY0LTMuOC04LjY0LTMuMTYtMTMuMTkgMS4wNS01LjgxIDUuOTMtMTAuNSAxMS42Mi0xMS44MnpNMTAzLjk3IDExMS44NmMtLjEtMy4yNCAyLjc3LTYuMTEgNi4wMS02LjAyIDcuMzQtLjE2IDE0LjY4IDAgMjIuMDItLjA4IDIuNDUtLjAyIDUuMzUtLjAzIDcuMDQgMi4wOCAxLjU3IDEuNjIgMS42IDMuOTkgMS42IDYuMTEtLjAzIDE4LjQxLS4wMSAzNi44Mi0uMDEgNTUuMjMgMy44NC0uMDcgOS4wNy0uNjMgMTAuODcgMy43NCAxLjIgNC41Ny4zNSA5LjQyLjU5IDE0LjExLjQ1IDMuNTktMi4zNCA3LjI4LTYuMSA3LjE0LTExLjY0LjEyLTIzLjI5LjAyLTM0LjkzLjA0LTMuMTkuMzEtNi42OS0xLjc4LTctNS4xNS0uMzQtMy42Ny0uMDgtNy4zNS0uMTctMTEuMDMtLjAxLTIuNDMtLjA1LTUuMzMgMi4wNy03IDIuNDMtMi4yMiA1Ljk1LTEuNTEgOC45NS0xLjY0LS4wMS0xMi45NCAwLTI1Ljg4IDAtMzguODItMy44LjE1LTkuMDguNDUtMTAuNi00LS44Mi00LjgzLS4zLTkuODItLjM0LTE0LjcxeiIvPg0KICA8L2c+DQo8L3N2Zz4="></div>
                                <div class="basket_but_wrap">
                                    <div class="basket_but" @click="deletFromBasket(item.id)">
                                        <img class="basket_but_img" src="../assets/img/cancel.svg"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-control-wrap" v-show="basketState">
                    <div class="content-control">
                        <!-- <p class="control-text">Ваш заказ:</p> -->
                        <!-- <p class="sum">
                            <span class="sum-span">{{ content.length }}</span>
                            товара на сумму
                            <span class="sum-span">{{ main_sum }}</span>
                                Руб
                        </p> -->
                        <button class="buy desktop_view" @click="buyClick()">ОФОРМИТЬ</button>
                        <app-order class="mobile_view" v-on:closeOrder="closeOrder()" :orderList="content"></app-order>
                    </div>
                </div>
            </div>
            <p class="empty-basket-text" v-else>Ваша корзина пуста</p>
        </div>
        <app-soc-cop></app-soc-cop>
        <div class="over" v-if="popup" @click="closePopup()"></div>
        <app-order v-if="popup" v-on:closeOrder="closeOrder()" :orderList="content"></app-order>
        <div class="over-order-buy-send" v-if="orderBuySendCheck" @click="closeOrderConfirm()"></div>
        <transition name="fade">
        <app-order-buy-send v-if="orderBuySendCheck" v-on:closeOrderBuySend="closeOrderConfirm()"></app-order-buy-send>
        </transition>
  </div>
</template>

<script>
import SocialCopir from './SocialCopir.vue'
import Order from './Order.vue'
import OrderBuySend from './OrderBuySend.vue'
export default {
  name: 'Basket',
  data () {
    return {
        popup: false,
        content: [],
        main_sum: 0,
        orderBuySendCheck: false,
    }
  },
  methods: {
        buyClick() {
            this.popup = true;
        },
        closePopup() {
            this.popup = false;
        },
        closeOrder() {
            this.popup = false;
            this.orderBuySendCheck = true;
            var self = this;
            setTimeout(function(){
                self.orderBuySendCheck = false;
            }, 2000);
        },
        deletFromBasket(item_id) {
            for (let elem in this.content) {
                if (this.content[elem].id === item_id) {
                    this.content.splice(elem, 1)
                    localStorage.setItem('basket', JSON.stringify(this.content));
                    this.$store.dispatch('checkBasket');
                }
            }
        },
        closeOrderConfirm() {
            this.orderBuySendCheck = false;
        },
        goToItem ( item ) {
            this.$router.push({path: '/catalog/' + item.mark.name + '/' + item.id});
        },
        goBack() {
          window.history.back()
        }
  },
  components: {
      'AppSocCop': SocialCopir,
      'AppOrder': Order,
      'AppOrderBuySend': OrderBuySend,
  },
  mounted() {
      this.content = JSON.parse(localStorage.getItem('basket'));
  },
  watch: {
      content(newContent, oldContent) {
          this.main_sum = 0
          for (let item of this.content) {
              this.main_sum += item.price
          }
      }
  },
  computed: {
    basketState(){
      return this.$store.state.basketState
    }
  },
  beforeCreate(){
        $.fn.fullpage.destroy('all');
    },
}
</script>

<style lang="scss" scoped>

.back_catalog{
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -2;
}
.top_pane{
    position:absolute;
    width: 100%;
    top: 20vh;
    text-align: left;
}

.basket-main_wrap_content{
    position: absolute;
    top: 27vh;
    width: 100%;
    height: 50%;
}
.basket-wrap_content{
    width: 74%;
    min-width: 1000px;
    margin: auto;
    height: 100%;
}
.basket-content-wrap-body{
    width:100%;
    height: 78%;
    overflow-y: auto;
}
.top_pane_wrap{
    width: 74%;
    min-width: 1000px;
    margin: auto;
}
.top_pane_text{
    font-family: TextProLight;
    font-size: 12pt;
    float: left;
}
.top_pane_count{
    font-size: 12pt;
    font-family: TextProMedium;
    float: left;
    margin-left: 5px;
}
.content-control-wrap{
    width:100%;
    height: auto;
    float: left;
    margin-top: 20px;
}
.content-control{
    width:97.5%;
    height:auto;
    float:left;
    text-align: right;
}
.basket-content{
    display: grid;
    width: 100%;
    height: auto;
    grid-gap: 0px;
    grid-template-columns: repeat(auto-fit, 50%);
    grid-template-rows: repeat(auto-fit);
}
.basket-content_item{
    float: left;
    height: 80px;
    margin-bottom: 20px;
}
.basket-content_item_wrap{
    width:95%;
    height: 100%;
    background-color: rgba($color: gray, $alpha: 0.1)
}
.basket-content_item_wrap img{
    width: 130px;
    height: 100%;
    object-fit: cover;
    float:left;
}
.text{
    width: 35%;
    height: 100%;
    text-align: left;
    float: left;
    margin-left: 10px;
}
.text p{
    line-height: 1;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
.name{
    font-family: TextProMedium;
    font-size: 12pt;
    margin-bottom: 0;
    margin-top: 10px;
}
.descript-basket{
    font-family: TextProLight;
    font-size: 10pt;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-top: 8px;
    margin-bottom: 0;
}
.more{
    font-size: 12pt;
    font-family: TextProLight;
    color: gray;
    text-decoration: underline;
    margin-top: 8px;
    cursor: pointer;
}
.price{
    padding-top: 15px;
    color: #cba35d;
    font-size: 12pt;
    font-family: TextProMedium;
}
.price_wrap{
    float:left;
    width: 20%;
    height: 100%;
    text-align: center;
}
.basket_but_wrap{
    width: 40px;
    height: 100%;
    float: right;
}
.basket_but{
    margin-top: 29px;
    width: 20px;
    height: 20px;
    float: left;
    background-color:#cf3835;
    cursor: pointer;
}
.basket_but:hover{
    background-color: #ce4c4c;
}
.basket_but:active{
    background-color: #cf3835;
}
.basket_but img{
    width: 10px;
    height: 10px;
    margin-top: 5px;
    margin-left: 5px;
}
.content-control p, span{
    line-height: 0.4;
    margin-top: 0;
}
.control-text{
    font-size: 12pt;
    font-family: TextProMedium;
}
.sum-span{
    font-size: 14pt;
    font-family: TextProMedium;
}
.sum{
    font-size: 12pt;
    font-family: TextProLight;
}
.buy{
    background-color: #cf3835;
    font-size: 12pt;
    font-family: TextProMedium;
    outline: none;
    border: none;
    padding: 10px 23px;
    padding-top: 12px;
    margin-top: 10px;
    cursor: pointer;
}
.buy:hover{
    background-color: #ce4c4c;
}
.buy:active{
    background-color: #cf3835;
}
.wrap_content::-webkit-scrollbar {
    width: 10px;
}

.wrap_content::-webkit-scrollbar-track {
    border-radius: 5px;
    border: 1px solid rgba(128, 128, 128, 0.5);
}

.wrap_content::-webkit-scrollbar-thumb {
    background-color: rgba($color: #ffffff, $alpha: 0.2);
    border-radius: 5px;
    border: 1px solid rgba(128, 128, 128, 0.5);
}
.over{
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    background-color: rgba($color: #000000, $alpha: 0.5);
    position: fixed;
    z-index: 998;
}
.basket-content-wrap-body::-webkit-scrollbar {
    width: 10px;
}

.basket-content-wrap-body::-webkit-scrollbar-track {
    border-radius: 5px;
    border: 1px solid rgba(128, 128, 128, 0.5);
}

.basket-content-wrap-body::-webkit-scrollbar-thumb {
    background-color: rgba($color: #ffffff, $alpha: 0.2);
    border-radius: 5px;
    border: 1px solid rgba(128, 128, 128, 0.5);
}
.empty-basket-text{
    font-size: 25pt;
    font-family: TextProMedium;
    color: #cccccc;
    padding-top: 40px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.over-order-buy-send{
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    background-color: rgba($color: #000000, $alpha: 0.5);
    position: fixed;
    z-index: 998;
}

.mobile_more_icon {
  display: none;
}

.mobile_view {
  display: none;
}

@media all and (max-width: 1024px) {
  .back_catalog {
    display: none;
  }

  .desktop_view {
    display: none;
  }

  .mobile_view {
    display: block;
  }

  #wrap_catalog {
    padding: 15vh 5vh 0;
    width: auto;

    #social-copir {
      padding: 5vh 0;
    }
  }

  .top_pane,
  .basket-main_wrap_content {
    position: static;
    height: auto;
  }

  .top_pane_wrap {
    width: auto;
    min-width: 0;
    text-align: left;

    p {
      float: none;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .basket-wrap_content {
    width: 100%;
    min-width: 0;
    height: auto;
  }

  .basket-content-wrap-body {
    height: auto;
    overflow: visible;
  }

  .basket-content {
    display: block;
  }

  .basket-content_item {
    float: none;
  }

  .basket-content_item_wrap {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    & > img {
      display: none;
    }
  }

  .text {
    width: 65%;
    float: none;
    padding-left: 2vw;
    height: auto;

    p {
      margin: 0;
    }

    .descript-basket,
    .more {
      display: none;
    }
  }

  .price_wrap {
    float: none;
    width: 65%;
    padding-left: 4vw;
    height: auto;
    text-align: left;

    p {
      margin: 0;
      padding: 0;
    }
  }

  .basket_but_wrap {
    width: auto;
    height: auto;
    float: none;
    position: absolute;
    right: 4vw;
    top: 50%;
  }

  .basket_but {
    margin-top: -15px;
    width: 30px;
    height: 30px;

    img {
      margin-left: 10px;
      margin-top: 10px;
    }
  }

  .mobile_more_icon {
    display: block;

    img {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 17vw;
      top: 50%;
      margin-top: -10px;
    }
  }

  .content-control {
    text-align: left;
    padding-bottom: 60px;
    float: none;
  }

  .content-control-wrap {
    float: none;
    margin-top: 40px;
  }

  .empty-basket-text {
    padding-top: 0;
    height: 45vh;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Basket.vue